import * as _ from 'lodash'
import { IBusinessObject } from '../PA.Core/PA.Core.IF.BO';
import { IHaveTags } from '../PA.Core/PA.Core.IF.Aspects';
import { IDateRange, IMessageProvider, IProgressProvider, MessageType } from '../PA.Core/PA.Core.IF.Basic';
import { PAdbContext } from '../PA.Core/PAdbContext';
import { IdentityProvider } from '../PA.Core/Basic/Identity'
import { MessageProvider } from '../PA.Core/Basic/Messages'
import { ProgressProvider } from '../PA.Core/Basic/Progress'
import {
    defaultRowValues,
    WB_DistribChannelRow,
    WB_DivisionRow,
    WB_FinishedProductRelationshipRow,
    WB_FinishedProductRow,
    WB_MasterDataSetRow,
    WB_ProductGroupExternalRelationshipRow,
    WB_ProductGroupRelationshipRow,
    WB_ProductGroupRow,
    WB_ProductGroupSalesAreaRow,
    WB_ProductGroupTagRelationshipRow,
    WB_ProductGroupUOMRow,
    WB_ProductTypeRow,
    WB_SalesAreaRow,
    WB_SalesOrgRow,
    WB_SourceRow,
    WB_TagRow,
    WB_TagSourceRow
} from "../PA.Core/PAdbSchemaRows";
import { IwbFinishedProduct, IwbProductGroup } from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_DistribChannel,
    esWB_Division,
    esWB_Finished_Product,
    esWB_Finished_Product_Relationship,
    esWB_MasterData_Set, esWB_Product_Attribute,
    esWB_Product_Group,
    esWB_Product_Group_External_Relationship,
    esWB_Product_Group_Relationship,
    esWB_Product_Group_SalesArea,
    esWB_Product_Group_Tag_Relationship,
    esWB_Product_Group_UOM, esWB_Product_Type,
    esWB_Product_UOM,
    esWB_SalesArea,
    esWB_SalesOrg,
    esWB_Source,
    esWB_Tag,
    esWB_Tag_Source
} from "../PA.Core/PAdbSchema";
import { ESRecord } from "../PA.Core/lib/ESRecord";
import { ESDataStore } from "../PA.Core/lib/ESDataStore";
import { CreateOptions, ESRecordResolver } from "../PA.Core/lib/ESRecordResolver"
import { ASync } from "../PA.Core/Basic/ASync";
import { ProductGroupBOValidations } from "./ProductGroupBO.Validations";
import { ProductHierarchyContext } from "../PA.Utils/ProductHierarchyContext";
import { LeaseRegistry } from "../PA.Utils/LeaseRegistry";
import { AuditLogType } from "../PA.Core/PA.Core.IF.Audit";
import { AuditService } from "../PA.Core/Security/AuditService";
import { ConsumerProductService } from "../PA.MD.Services/ConsumerProductService";
import {
    IEquivOptions,
    IFilterOptions,
    IFilterOptionsFilter
} from "../PA.MD.Core/PA.MD.IF.Aspects";
import { ProductGroupBOAudit } from "./ProductGroupBO.Audit";
import { BehaviorSubject } from "rxjs";
import { PAEnvironment } from "../PA.Core/PAEnvironment";
import * as bases from "bases"
import { IUOMCalculateOptions, ProductUOMUtils } from "../PA.MD.Services/ProductUOMUtils";
import { DateUtils } from "../PA.Core/Basic/Dates";
import { ProductHierarchyService } from "../PA.MD.Services/ProductHierarchyService";
import { IProductCreateLoadOptions, IProductType, ProductHeaderFields } from "../PA.MD.Core/PA.MD.IF.Product";
import { IEntity } from "../PA.MD.Core/PA.MD.IF.Entity";
import { ProductEntity } from "../PA.MD.Entity/ProductEntity";
import { MDUsageService } from "../PA.MD.Services/MDUsageService";

export interface IGenerateUOMOptions
    extends IUOMCalculateOptions {
    wbPrdHId: number,
    HierarchyEffectiveStartDt?: Date,
    HierarchyEffectiveEndDt?: Date
}

const ProductLoadOptions_default: IProductCreateLoadOptions = {}

export class ProductGroupBO
    implements IBusinessObject,
        IHaveTags {
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_ProductGroup: WB_ProductGroupRow;

    dctAuditedDeletes: { [id: number]: number }

    constructor(options?: IProductCreateLoadOptions) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({ id: 0, name: 'New ProductGroup' });

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_ProductGroup = undefined;

        this.dctAuditedDeletes = {}

        this.IHaveTagsLoaded_init()
        this.IHaveSalesAreas_init()
        this.Entity_init()
    }

    get WB_ProductGroup(): WB_ProductGroupRow {
        return this.drWB_ProductGroup;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;
        self.LoadProgressProvider.start("Creating Product Group");

        let internalOnComplete = self._OnLoadComplete = (async () => {

            try {

                self.LoadOptions = options || {};
                _.defaults(self.LoadOptions, ProductLoadOptions_default)

                if ('dbContext' in self.LoadOptions)
                    self.dbContext = self.LoadOptions.dbContext;
                else
                    self.dbContext = new PAdbContext();

                if (this.dbContext == undefined) {
                    var sError = "Unable to determine dbContext for new ProductGroup.";
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(sError);
                    return self;
                }

                // Create record using dbContext
                let newProductGroupRow: WB_ProductGroupRow = <WB_ProductGroupRow>await self.dbContext.createRecordWithKey(esWB_Product_Group)
                newProductGroupRow.setDefaults()
                self.drWB_ProductGroup = newProductGroupRow;
                self.dbContext.add(esWB_Product_Group, newProductGroupRow)
                self.WB_ProductGroup.cif.PRODUCT_GROUP_ID = bases.toBase(self.WB_ProductGroup.cif.WB_PRDGRP_ID, 26);
                self.Identity.setAll(self.WB_ProductGroup.cif.WB_PRDGRP_ID, self.WB_ProductGroup.cif.PRODUCT_GROUP_ID, self.WB_ProductGroup.cif.PRODUCT_GROUP_NAME);
                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                self.Identity.listenToRecordUpdates(self.WB_ProductGroup, 'WB_PRDGRP_ID', 'PRODUCT_GROUP_ID', 'PRODUCT_GROUP_NAME')


                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;

                // Create Defaults
                await self.applyCreateOptions()

                await self.IProductType_OnLoadComplete()
                await self.OnIHaveTagsLoaded

                self.Identity.setAll(self.WB_ProductGroup.cif.WB_PRDGRP_ID, self.WB_ProductGroup.cif.PRODUCT_GROUP_ID, self.WB_ProductGroup.cif.PRODUCT_GROUP_NAME);

                //await self.IHaveProductType_OnLoadComplete()

                await self.Entity_OnLoadComplete()

                self.LoadProgressProvider.finish();
                return self

            } catch (err) {
                self.LoadProgressProvider.exception(err)
                return self
            }

        })();

        return internalOnComplete
    }

    async applyCreateOptions() {
        const self = this

        let sId = self.CreateOptions?.sId || self.LoadOptions?.sId
        if (!_.isEmpty(sId))
            self.WB_ProductGroup.cif.PRODUCT_GROUP_ID = sId

        let sName = self.CreateOptions?.sName || self.LoadOptions?.sName
        if (!_.isEmpty(sName))
            self.WB_ProductGroup.cif.PRODUCT_GROUP_NAME = sName


        let sKeySetId = self.CreateOptions?.sKeySetId || self.LoadOptions?.sKeySetId
        if (!_.isEmpty(sKeySetId))
            self.WB_ProductGroup.cif.PRODUCT_GROUP_SET_ID = sKeySetId

        // Set Master Data Set
        let wbMasterDataSet = self.CreateOptions?.wbMasterDataSetId || self.LoadOptions?.wbMasterDataSetId
        if (_.isNumber(wbMasterDataSet)) {
            let mds: WB_MasterDataSetRow = <any>await self.dbContext.find(esWB_MasterData_Set, wbMasterDataSet)
            if (mds) {
                self.WB_ProductGroup.WB_MasterDataSetRow = mds
                self.WB_ProductGroup.cif.WB_MDSET_ID = wbMasterDataSet
                let mruValue = new MDUsageService()
                await mruValue.saveMDSetUsage(wbMasterDataSet)
            }
        }
        // Set Source
        let wbSource = self.CreateOptions?.wbSourceId || self.LoadOptions?.wbSourceId
        if (_.isNumber(wbSource)) {
            let src: WB_SourceRow = <any>await self.dbContext.find(esWB_Source, wbSource)
            if (src) {
                self.WB_ProductGroup.cif.SOURCE_ID = src.cif.SOURCE_ID
            }
        }

        // Add SalesArea
        let wbSalesAreaId = self.CreateOptions?.wbSalesAreaId || self.LoadOptions?.wbSalesAreaId
        if (_.isNumber(wbSalesAreaId) && !_.isArray(wbSalesAreaId))
            wbSalesAreaId = [wbSalesAreaId]
        for (let aSalesAreaId of (wbSalesAreaId || [])) {
            let newRec = await self.addSalesArea(aSalesAreaId)
        }

        // Set Product Type
        let wbPrdMId = self.CreateOptions?.wbPrdMId || self.LoadOptions?.wbPrdMId
        if (_.isNumber(wbPrdMId)) {
            let aValue: WB_ProductTypeRow = <any>await self.dbContext.find(esWB_Product_Type, wbPrdMId)
            if (aValue) {
                self.WB_ProductGroup.cif.WB_PRDM_ID = aValue.cif.WB_PRDM_ID
            }
        }

    }

    Load(anId: number | string, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        let internalOnComplete = self._OnLoadComplete = (async () => {

            try {

                self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

                if (self.bIsLoaded) {
                    self.LoadProgressProvider.exception("Product Group already loaded.");
                    self._OnLoadComplete = undefined;
                    return self;
                }

                self.LoadOptions = options || {};

                if ('dbContext' in self.LoadOptions)
                    self.dbContext = self.LoadOptions.dbContext;
                else
                    self.dbContext = new PAdbContext();

                if (_.isEmpty(this.dbContext)) {
                    const sError = "Unable to determine dbContext for new ProductGroup.";
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(sError);
                    return self;
                }

                if ('RecordResolver' in self.LoadOptions) {
                    recordResolver = (<any>self.LoadOptions).RecordResolver
                    recordResolverLoadPromise = ASync.resolve()
                } else {
                    recordResolver = ProductGroupBO.createRecordResolver({ dbContext: self.dbContext })
                    recordResolverLoadPromise = ProductGroupBO.setupRecordResolver(recordResolver, [<number>anId])
                }


                await recordResolverLoadPromise

                let aProduct_GroupRow: any = recordResolver.get(esWB_Product_Group, anId)

                if (_.isEmpty(aProduct_GroupRow)) {
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception("Id not found.");
                    return self;
                }

                aProduct_GroupRow.WB_ProductGroupRelationshipRows_Parent.forEach((val: any, index: any, arr: any) => {
                    if (val.DELETED_IND === "1") {
                        arr.splice(index, 1)
                    }
                })

                aProduct_GroupRow.WB_ProductGroupRelationshipRows_Children.forEach((val: any, index: any, arr: any) => {
                    if (val.DELETED_IND === "1") {
                        arr.splice(index, 1)
                    }
                })


                aProduct_GroupRow.WB_ProductGroupTagRelationshipRows.forEach((val: any, index: any, arr: any) => {
                    if (val.DELETED_IND === "1") {
                        arr.splice(index, 1)
                    }
                })

                self.drWB_ProductGroup = aProduct_GroupRow;
                self.Identity.setAll(self.WB_ProductGroup.cif.WB_PRDGRP_ID, self.WB_ProductGroup.cif.PRODUCT_GROUP_ID, self.WB_ProductGroup.cif.PRODUCT_GROUP_NAME);
                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                self.Identity.listenToRecordUpdates(self.WB_ProductGroup, 'WB_PRDGRP_ID', 'PRODUCT_GROUP_ID', 'PRODUCT_GROUP_NAME')

                let mruValue = new MDUsageService()
                await mruValue.saveMDSetUsage(self.drWB_ProductGroup.cif.WB_MDSET_ID)
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;

                await self.IProductType_OnLoadComplete()
                await self.OnIHaveTagsLoaded
                await self.Entity_OnLoadComplete()

                self.LoadProgressProvider.finish();
                return self
            } catch (err: any) {
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(err);
                return self;
            }
            ;

        })();

        return internalOnComplete
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    get bIsLowestPPG(): boolean {
        return (this.WB_ProductGroup.WB_ProductTypeRow && this.WB_ProductGroup.WB_ProductTypeRow.cif.PRDM_ID == "PPG")
    }

    async Validate(options?: any): Promise<IBusinessObject> {
        const self = this;

        try {
            self._bIsValidated = false;
            self.ValidateMessageProvider.clearMessages();
            self.ValidateProgressProvider.start("Validating " + self.WB_ProductGroup.cif.PRODUCT_GROUP_NAME + "(" + self.WB_ProductGroup.cif.PRODUCT_GROUP_ID + ")");

            self.ValidateOptions = options || {};

            if (_.isEmpty(self.dbContext)) {
                let sError = "Unable to determine dbContext for to Validate Product_Group.";
                self.ValidateProgressProvider.exception(sError);
                return self
            }

            await ProductGroupBOValidations.ValidateEmptyFields(self)
            if (self.productEntity) {
                await self.productEntity.Validate()
                self.ValidateMessageProvider.addMessages(self.productEntity.ValidateMessageProvider.Messages)
            }

            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                self._bIsValidated = false;
            } else {
                self._bIsValidated = true;
            }
            self.ValidateProgressProvider.finish();
            return self;

        } catch (err) {
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);
            return self;

        }
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: { bSkipValidations?: boolean }): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: { bSkipValidations?: boolean }): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: { bSkipValidations?: boolean }): Promise<IBusinessObject> {
        const self = this;
        const wbProductGroup = <IwbProductGroup>self.drWB_ProductGroup;
        let opts = options || {}
        let auditService: AuditService = undefined

        try {
            self.SaveProgressProvider.start("Saving " + wbProductGroup.PRODUCT_GROUP_NAME + "(" + wbProductGroup.PRODUCT_GROUP_ID + ")");

            if (this.dbContext == undefined) {
                self._bIsSaved = false;
                let sError = "Unable to determine dbContext to Save Product Group.";
                self.SaveProgressProvider.exception(sError);
                return self
            }

            self.SaveOptions = options || {};

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            if (opts.bSkipValidations)
                self._bIsValidated = true
            else {

                await self.Validate({})
                if (!self.bIsValidated) {
                    self._bIsSaved = false;
                    self.SaveProgressProvider.finish();
                    return self
                }
            }

            auditService = await ProductGroupBOAudit.ProductGroupAuditBO(self)

            //iterate through records here and find classes, create a dictionary
            let dctLeaseClasses: { [id: string]: string } = {};
            let propsToCheck: string[] = ["WB_PRDH_ID", "WB_PRDGRP_ID", "WB_PROD_ID", "WB_PRDGRP_ID_PRNT", "EFFECTIVE_START_DT", "EFFECTIVE_END_DT", "DELETED_IND"];
            let leaseClasses: string[];
            let prdHWbID: number;
            let allPrdGrpRelRows: any[] = [];
            allPrdGrpRelRows.push.apply(allPrdGrpRelRows, self.drWB_ProductGroup.WB_ProductGroupChildProductRows);
            allPrdGrpRelRows.push.apply(allPrdGrpRelRows, self.drWB_ProductGroup.WB_ProductGroupRelationshipRows_Children);
            allPrdGrpRelRows.push.apply(allPrdGrpRelRows, self.drWB_ProductGroup.WB_ProductGroupRelationshipRows_Parent);

            _.forEach(allPrdGrpRelRows, (aRel: ESRecord) => {
                if (!aRel._rowExists || aRel._rowDeleted || aRel.hasChanges({ properties: propsToCheck })) {

                    if (aRel instanceof WB_ProductGroupRelationshipRow) {
                        prdHWbID = (aRel as WB_ProductGroupRelationshipRow).cif.WB_PRDH_ID;
                    } else if (aRel instanceof WB_FinishedProductRelationshipRow) {
                        prdHWbID = (aRel as WB_FinishedProductRelationshipRow).cif.WB_PRDH_ID
                    } else {
                        return;
                    }

                    leaseClasses = ProductHierarchyContext.getLeaseClasses(prdHWbID);
                    _.forEach(leaseClasses, (aClassName) => {
                        dctLeaseClasses[aClassName] = aClassName;
                    })
                }
            });

            await saveFunction(esWB_Product_Group, self.drWB_ProductGroup, {})

            let tasks: Promise<any>[] = []
            tasks.push(saveFunction(esWB_Product_Group_SalesArea, self.drWB_ProductGroup.WB_ProductGroupSalesAreaRows))
            tasks.push(saveFunction(esWB_Product_Group_Relationship, self.drWB_ProductGroup.WB_ProductGroupRelationshipRows_Children));
            tasks.push(saveFunction(esWB_Product_Group_Relationship, self.drWB_ProductGroup.WB_ProductGroupRelationshipRows_Parent));
            tasks.push(saveFunction(esWB_Finished_Product_Relationship, self.drWB_ProductGroup.WB_ProductGroupChildProductRows));
            tasks.push(saveFunction(esWB_Product_Group_External_Relationship, self.drWB_ProductGroup.WB_ProductGroupExternalRelationshipRows));
            tasks.push(saveFunction(esWB_Product_Group_Tag_Relationship, self.drWB_ProductGroup.WB_ProductGroupTagRelationshipRows));
            tasks.push(saveFunction(esWB_Product_Group_UOM, self.WB_ProductGroup.WB_ProductGroupUOMRows));
            tasks.push(saveFunction(esWB_Product_Attribute, self.WB_ProductGroup.WB_ProductAttributeRows));

            await Promise.all(tasks)


            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true;
                    //invalidate here
                    if (!_.isEmpty(_.values(dctLeaseClasses))) {
                        LeaseRegistry.generateLeaseInvalidationByClassList(_.values(dctLeaseClasses));
                    }
                })
            } else {
                self._bIsSaved = true;
                //invalidate leases here
                if (!_.isEmpty(_.values(dctLeaseClasses))) {
                    LeaseRegistry.generateLeaseInvalidationByClassList(_.values(dctLeaseClasses));
                }

            }
            self.SaveProgressProvider.finish();
            return self;
        } catch (err) {
            self.SaveProgressProvider.exception(err);
            return self
        } finally {
            if (auditService)
                await auditService.Save(bBatch)
        }
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        const wbProductGroup = <IwbProductGroup>self.drWB_ProductGroup;
        self.DeleteMessageProvider.clearMessages();
        self.DeleteProgressProvider.start("Deleting " + wbProductGroup.PRODUCT_GROUP_NAME + "(" + wbProductGroup.PRODUCT_GROUP_ID + ")");
        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the ProductGroup
            if (!self.drWB_ProductGroup.bManualInd) {
                let sMsg = "Product Group created externally cannot be deleted."
                self.DeleteMessageProvider.addMessage({
                    code: "ManualInd",
                    type: MessageType.Error,
                    title: sMsg,
                    description: sMsg
                })
                self.DeleteProgressProvider.finish()
                resolve(self)
                return
            }

            // 2. If Valid, mark all the records for deletion.
            self.drWB_ProductGroup.markDeleted()
            let deleteRowIfActive = (aRow: ESRecord) => {
                if (aRow.isActive)
                    aRow.markDeleted()
            }

            _.forEach(self.drWB_ProductGroup.WB_ProductGroupTagRelationshipRows, deleteRowIfActive)
            _.forEach(self.drWB_ProductGroup.WB_ProductGroupExternalRelationshipRows, deleteRowIfActive)
            _.forEach(self.drWB_ProductGroup.WB_ProductGroupChildProductRows, deleteRowIfActive)
            _.forEach(self.drWB_ProductGroup.WB_ProductGroupRelationshipRows_Parent, deleteRowIfActive)
            _.forEach(self.drWB_ProductGroup.WB_ProductGroupRelationshipRows_Children, deleteRowIfActive)
            _.forEach(self.drWB_ProductGroup.WB_ProductGroupAttributeRows, deleteRowIfActive)
            _.forEach(self.drWB_ProductGroup.WB_ProductGroupSalesAreaRows, deleteRowIfActive)

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>


    //<editor-fold desc = "Add/ Remove Hierarchy Relationship operations">

    //add or delete parent-child
    addProductGroupChildProduct(aWbPrdId: number): Promise<IBusinessObject> {
        var self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            // first find out if record exists.
            var found = false

            _.forEach(self.drWB_ProductGroup.WB_ProductGroupChildProductRows, (aPrdGrpChildProdRow: WB_FinishedProductRelationshipRow) => {
                if (aPrdGrpChildProdRow.isActive && aPrdGrpChildProdRow.cif.WB_PRDGRP_ID == aWbPrdId) {
                    found = true
                    return false
                }
            })

            if (found) {
                return
            } // exists..
            var aPrdRow: WB_FinishedProductRow = undefined

            self.dbContext.find(esWB_Finished_Product, aWbPrdId)
                .then((aProdRecord: WB_FinishedProductRow) => {
                    aPrdRow = aProdRecord
                    if (_.isEmpty(aPrdRow)) {
                        resolve(self)
                        return
                    }

                    // create new records
                    return self.dbContext.createRecordWithKey(esWB_Finished_Product_Relationship)

                })
                .then((aPrdGrpChildProdRow: WB_FinishedProductRelationshipRow) => {
                    if (_.isEmpty(aPrdRow)) {
                        resolve(self)
                        return
                    }
                    aPrdGrpChildProdRow.setDefaults()
                    aPrdGrpChildProdRow.cif.WB_PROD_ID = aPrdRow.cif.WB_PROD_ID
                    aPrdGrpChildProdRow.WB_FinishedProductRow = aPrdRow
                    aPrdGrpChildProdRow.cif.WB_PRDGRP_ID_PRNT = self.drWB_ProductGroup.cif.WB_PRDGRP_ID
                    aPrdGrpChildProdRow.WB_ProductGroupRow
                    aPrdGrpChildProdRow.cif.MANUAL_IND = "1"
                    self.dbContext.add(esWB_Finished_Product_Relationship, aPrdGrpChildProdRow)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeProductGroupChildProduct(aWbPrdGrpChildProdRId: number): Promise<IBusinessObject> {
        var self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            _.forEach(self.drWB_ProductGroup.WB_ProductGroupChildProductRows, (aPrdGrpChildProdRow: WB_FinishedProductRelationshipRow) => {
                if (aPrdGrpChildProdRow.isActive && aPrdGrpChildProdRow.cif.WB_PRODR_ID == aWbPrdGrpChildProdRId) {
                    aPrdGrpChildProdRow.cif.DELETED_IND = "1"
                    aPrdGrpChildProdRow.markDeleted()
                }
            })

            resolve(self)
        })
    }

    //add or delete parent-child
    addRel(aWbPrdGrpId: number, sType: string): Promise<IBusinessObject> {
        var self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            // first find out if record exists.
            var found = false

            if (sType === 'Child')
                _.forEach(self.drWB_ProductGroup.WB_ProductGroupRelationshipRows_Children, (aPrdGrpChildRelRow: WB_ProductGroupRelationshipRow) => {
                    if (aPrdGrpChildRelRow.isActive && aPrdGrpChildRelRow.cif.WB_PRDGRP_ID == aWbPrdGrpId) {
                        found = true
                        return false
                    }
                })
            else
                _.forEach(self.drWB_ProductGroup.WB_ProductGroupRelationshipRows_Parent, (aPrdGrpParentRelRow: WB_ProductGroupRelationshipRow) => {
                    if (aPrdGrpParentRelRow.isActive && aPrdGrpParentRelRow.cif.WB_PRDGRP_ID_PRNT == aWbPrdGrpId) {
                        found = true
                        return false
                    }
                })

            if (found) {
                return
            } // exists..
            var aPrdGrpRow: WB_ProductGroupRow = undefined

            self.dbContext.find(esWB_Product_Group, aWbPrdGrpId)
                .then((aPGRecord: WB_ProductGroupRow) => {
                    if (_.isEmpty(aPGRecord)) {
                        resolve(self)
                        return
                    }
                    aPrdGrpRow = aPGRecord

                    // create new records
                    return self.dbContext.createRecordWithKey(esWB_Product_Group_Relationship)

                })
                .then((aPrdGrpRelRow: WB_ProductGroupRelationshipRow) => {
                    aPrdGrpRelRow.setDefaults()
                    if (sType === 'Child') {
                        aPrdGrpRelRow.cif.WB_PRDGRP_ID = aWbPrdGrpId
                        aPrdGrpRelRow.WB_ProductGroupRowChild = aPrdGrpRow
                        aPrdGrpRelRow.cif.WB_PRDGRP_ID_PRNT = self.drWB_ProductGroup.cif.WB_PRDGRP_ID
                    } else {
                        aPrdGrpRelRow.cif.WB_PRDGRP_ID_PRNT = aWbPrdGrpId
                        aPrdGrpRelRow.WB_ProductGroupRowParent = aPrdGrpRow
                        aPrdGrpRelRow.cif.WB_PRDGRP_ID = self.drWB_ProductGroup.cif.WB_PRDGRP_ID
                    }
                    self.dbContext.add(esWB_Product_Group_Relationship, aPrdGrpRelRow)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeRel(aWbChildId: number, sType: string): Promise<IBusinessObject> {
        var self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            if (sType === 'Child')
                _.forEach(self.drWB_ProductGroup.WB_ProductGroupRelationshipRows_Children, (aPrdGrpRelRow: WB_ProductGroupRelationshipRow) => {
                    if (aPrdGrpRelRow.isActive && aPrdGrpRelRow.cif.WB_PRDGRP_ID == aWbChildId) {
                        aPrdGrpRelRow.markDeleted()
                    }
                })
            else
                _.forEach(self.drWB_ProductGroup.WB_ProductGroupRelationshipRows_Parent, (aPrdGrpRelRow: WB_ProductGroupRelationshipRow) => {
                    if (aPrdGrpRelRow.isActive && aPrdGrpRelRow.cif.WB_PRDGRP_ID_PRNT == aWbChildId) {
                        aPrdGrpRelRow.markDeleted()
                    }
                })

            resolve(self)
        })
    }

    //</editor-fold>


    //<editor-fold desc = "External Attributes operations">

    addExtAttribute(): Promise<IBusinessObject> {
        const self = this;

        return new Promise<IBusinessObject>((resolve, reject) => {
            self.dbContext.createRecordWithKey(esWB_Product_Group_External_Relationship)
                .then((aPrdGrpExtRelRow: WB_ProductGroupExternalRelationshipRow) => {
                    aPrdGrpExtRelRow.setDefaults();
                    aPrdGrpExtRelRow.cif.WB_PRDGRP_ID = self.drWB_ProductGroup.cif.WB_PRDGRP_ID;
                    aPrdGrpExtRelRow.WB_ProductGroupRow = self.drWB_ProductGroup;
                    self.dbContext.add(esWB_Product_Group_External_Relationship, aPrdGrpExtRelRow);
                    resolve(self)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    }

    removeExtAttribute(aWB_ProductGroupExtAttr_ID: number): Promise<IBusinessObject> {
        const self = this;

        return new Promise<IBusinessObject>((resolve, reject) => {
            _.forEach(self.drWB_ProductGroup.WB_ProductGroupExternalRelationshipRows, (aPrdGrpExtR: WB_ProductGroupExternalRelationshipRow) => {
                if (aPrdGrpExtR.isActive && aPrdGrpExtR.cif.WB_PRDGRPEXTR_ID == aWB_ProductGroupExtAttr_ID) {
                    aPrdGrpExtR.markDeleted();
                }
            });
            resolve(self)
        })
    }

    async synChildProductsUsingConsumerAttributes(): Promise<void> {
        const self = this;
        let aPrdGrp = self.WB_ProductGroup.cif
        const auditService = new AuditService(new PAdbContext({}));
        auditService.setReference("ProductGroup", aPrdGrp.WB_PRDGRP_ID);

        try {

            auditService.LogSync(AuditLogType.Info, `Starting Consumer Product Sync`);

            let dctMissing: { [id: number]: WB_FinishedProductRow & IwbFinishedProduct } = [];

            let arrCnsProductAttributeList: IFilterOptionsFilter[] = [];
            let arrPGExtRelRows = _.filter(self.drWB_ProductGroup.WB_ProductGroupExternalRelationshipRows, (a) => a.isActive)

            _.forEach(arrPGExtRelRows, (aExtR) => {
                switch (aExtR.cif.REL_TYPE_ID) {
                    case "Attribute":
                        arrCnsProductAttributeList.push({
                            Group_Set_ID: aExtR.cif.GROUP_SET_ID,
                            Attribute_ID: aExtR.cif.ATTRIBUTE_ID + '|' + aExtR.cif.SOURCE_ID,
                            Attribute_Value: aExtR.cif.ATTRIBUTE_VALUE,
                            Exclude: aExtR.cif.EXCLUDE_IND === '1'
                        })
                        break;
                    case "Attribute_Group":
                        arrCnsProductAttributeList.push({
                            Group_Set_ID: aExtR.cif.GROUP_SET_ID,
                            WB_PrdAttrGroup_ID: aExtR.cif.WB_PRDATTRGRP_ID,
                            Exclude: aExtR.cif.EXCLUDE_IND === '1'
                        })
                        break;
                }
            });

            //GenPolicy
            if ((aPrdGrp.CNSPRDDIM_PRDGENPOLICY === 'Sync') || (aPrdGrp.CNSPRDDIM_PRDGENPOLICY === 'AddOnly')) {
                let arrProdRelRows
                    = _.filter(self.drWB_ProductGroup.WB_ProductGroupChildProductRows,
                    (a) => a.isActive && (_.toNumber(a.cif.WB_PRDH_ID) == _.toNumber(aPrdGrp.CNSPRDDIM_WB_PRDH_ID)))

                if (_.toNumber(aPrdGrp.CNSPRDDIM_WB_PRDH_ID) <= 0) {
                    auditService.LogSync(AuditLogType.Error, `CNSPRDDIM_WB_PRDH_ID for ${aPrdGrp.PRODUCT_GROUP_ID} is not set`);
                    return;
                }

                if (_.isEmpty(arrCnsProductAttributeList)) {
                    auditService.LogSync(AuditLogType.Error, "Consumer Product Attribute list is empty");
                    return;
                }

                let cnsProdOpts: IFilterOptions = { filters: arrCnsProductAttributeList };

                //get list of cnsPrd based on cnsAttribs
                let cps = new ConsumerProductService();
                let arrConsumerProductIds = await cps.getConsumerProducts(cnsProdOpts)
                let arrConsumerProducts: WB_FinishedProductRow[] =
                    <any>await self.dbContext.findUsingCache(esWB_Finished_Product, arrConsumerProductIds)

                let dctConsumerProducts = _.keyBy(arrConsumerProducts, (a) => a.cif.WB_PROD_ID);
                dctMissing = await _.clone(dctConsumerProducts);


                _.forEach(arrProdRelRows, (aProdRelRow) => {
                    if ((!(aProdRelRow.cif.WB_PROD_ID in dctConsumerProducts))
                        && (aPrdGrp.CNSPRDDIM_PRDGENPOLICY === 'Sync')) {
                        aProdRelRow.markDeleted();
                    }

                    if (aProdRelRow.cif.WB_PROD_ID in dctConsumerProducts) {
                        delete dctMissing[aProdRelRow.cif.WB_PROD_ID];
                    }
                })

                for (let aPrdId in dctMissing) {
                    let prodRow = dctMissing[aPrdId]
                    let aNewRow = <WB_FinishedProductRelationshipRow>await self.dbContext.createRecordWithKey(esWB_Finished_Product_Relationship);
                    aNewRow.setDefaults();
                    aNewRow.cif.WB_PRDGRP_ID_PRNT = aPrdGrp.WB_PRDGRP_ID;
                    aNewRow.cif.WB_PROD_ID = prodRow.WB_PROD_ID;
                    aNewRow.WB_FinishedProductRow = prodRow
                    aNewRow.cif.WB_PRDH_ID = _.toNumber(aPrdGrp.CNSPRDDIM_WB_PRDH_ID);
                    aNewRow.cif.EFFECTIVE_START_DT = defaultRowValues.Min_Dt();
                    aNewRow.cif.EFFECTIVE_END_DT = defaultRowValues.Max_Dt();
                    self.dbContext.add(esWB_Finished_Product_Relationship, aNewRow);
                }
            }

            //equivPolicy
            if ((aPrdGrp.CNSPRDDIM_PRDEQVPOLICY === 'All') || (aPrdGrp.CNSPRDDIM_PRDEQVPOLICY === 'New Only')) {
                await self.EquivPolicy(auditService, arrCnsProductAttributeList, dctMissing);
            }

            auditService.LogSync(AuditLogType.Info, `Completed Consumer Product Sync`);

            await auditService.Save()

        } catch (e) {
            auditService.LogSync(AuditLogType.Info, `Error Consumer Product Sync: ${e}`);
            await auditService.Save()
        }

    };

    private async EquivPolicy(auditService: AuditService,
                              arrCnsProductAttributeList: IFilterOptionsFilter[],
                              dctMissing: { [id: number]: WB_FinishedProductRow & IwbFinishedProduct }): Promise<void> {

        const self = this;

        let aPrdGrp: WB_ProductGroupRow & IwbProductGroup = self.WB_ProductGroup
        let prodRelRec
            = _.filter(self.drWB_ProductGroup.WB_ProductGroupChildProductRows,
            (a) => a.isActive && (_.toNumber(a.cif.WB_PRDH_ID) == _.toNumber(aPrdGrp.CNSPRDDIM_WB_PRDH_ID)))

        if (_.toNumber(aPrdGrp.CNSPRDDIM_WB_PRDH_ID) <= 0) {
            auditService.LogSync(AuditLogType.Error, `CNSPRDDIM_WB_PRDH_ID for ${aPrdGrp.PRODUCT_GROUP_ID} is not set.`)
            return;
        }

        if (_.isEmpty(aPrdGrp.CNSPRDDIM_SIZEATTRIBS)) {
            auditService.LogSync(AuditLogType.Error, "CNSPRDDIM_SIZEATTRIBS is empty");
            return;
        }

        if (aPrdGrp.CNSPRDDIM_EQVSTDSIZE <= 0) {
            auditService.LogSync(AuditLogType.Error, "CNSPRDDIM_EQVSTDSIZE must be greater than 0");
            return;
        }

        let equivIds = aPrdGrp.CNSPRDDIM_SIZEATTRIBS.split(",");
        let cnsProdOpts: IEquivOptions = {
            filters: arrCnsProductAttributeList,
            equivAttributeIds: equivIds,
            standardSize: aPrdGrp.CNSPRDDIM_EQVSTDSIZE
        };

        let cps = new ConsumerProductService();
        let cnsPrdEquiv = await cps.getConsumerProductEquiv(cnsProdOpts);

        let dctEqv = _.keyBy(cnsPrdEquiv, (aPrd) => aPrd.wbProdId);

        //get equiv factors for all CnsPrd in WB_ProdR
        for (let aProdRelRow of prodRelRec) {
            let eqvRate = dctEqv[aProdRelRow.cif.WB_PROD_ID];

            if (_.isEmpty(eqvRate))
                continue;

            if (aPrdGrp.CNSPRDDIM_PRDEQVPOLICY === 'All') {
                aProdRelRow.cif.EQV_UNIT_RATE = eqvRate.equivFactor;
            }

            if (aPrdGrp.CNSPRDDIM_PRDEQVPOLICY === 'New Only') {
                if ((aProdRelRow.cif.WB_PROD_ID in dctMissing)) {
                    aProdRelRow.cif.EQV_UNIT_RATE = eqvRate.equivFactor;
                }
            }
        }

    }

    //</editor-fold>

    //<editor-fold desc = "Sales Area">

    _salesAreasChanged: BehaviorSubject<ProductGroupBO>

    IHaveSalesAreas_init() {
        this._salesAreasChanged = new BehaviorSubject<ProductGroupBO>(this)
    }

    get SalesAreasChanged(): BehaviorSubject<ProductGroupBO> {
        return this._salesAreasChanged
    }

    async addSalesArea(wbSalesAreaId: number): Promise<WB_ProductGroupSalesAreaRow> {
        const self = this

        for (let rel of self.WB_ProductGroup.WB_ProductGroupSalesAreaRows) {
            if (!rel.isActive)
                continue
            if (rel.cif.WB_SALESAREA_ID == wbSalesAreaId)
                return rel
        }

        let saRow: WB_SalesAreaRow = await self.dbContext.find(esWB_SalesArea, wbSalesAreaId)
        if (_.isEmpty(saRow))
            return undefined

        if (saRow.cif.WB_SALESORG_ID > 0) {
            let soRow: WB_SalesOrgRow = <any>await self.dbContext.find(esWB_SalesOrg, saRow.cif.WB_SALESORG_ID)
            if (!_.isEmpty(soRow) && _.isEmpty(saRow.WB_SalesOrgRow)) {
                saRow.WB_SalesOrgRow = soRow
            }
        }

        if (saRow.cif.WB_DIVISION_ID > 0) {
            let dvRow: WB_DivisionRow = <any>await self.dbContext.find(esWB_Division, saRow.cif.WB_DIVISION_ID)
            if (!_.isEmpty(dvRow) && _.isEmpty(saRow.WB_DivisionRow)) {
                saRow.WB_DivisionRow = dvRow
            }
        }

        if (saRow.cif.WB_DISTRIBCHANNEL_ID > 0) {
            let dcRow: WB_DistribChannelRow = <any>await self.dbContext.find(esWB_DistribChannel, saRow.cif.WB_DISTRIBCHANNEL_ID)
            if (!_.isEmpty(dcRow) && _.isEmpty(saRow.WB_DistribChannelRow)) {
                saRow.WB_DistribChannelRow = dcRow
            }
        }

        let newRow: WB_ProductGroupSalesAreaRow = <any>await self.dbContext.createRecordWithKey(esWB_Product_Group_SalesArea)
        newRow.setDefaults()
        newRow.WB_ProductGroupRow = self.WB_ProductGroup
        newRow.cif.WB_PRDGRP_ID = self.WB_ProductGroup.cif.WB_PRDGRP_ID
        newRow.WB_SalesAreaRow = saRow
        newRow.cif.WB_SALESAREA_ID = wbSalesAreaId

        self.SalesAreasChanged.next(self)
        return newRow
    }

    async removeSalesArea(wbPrdGrpSRId: number): Promise<void> {
        const self = this

        for (let rel of self.WB_ProductGroup.WB_ProductGroupSalesAreaRows) {
            if (!rel.isActive)
                continue
            if (rel.cif.WB_PRDGRPSR_ID == wbPrdGrpSRId) {
                rel.markDeleted()
                break
            }
        }

        self.SalesAreasChanged.next(self)
    }


    //</editor-fold>

    //<editor-fold desc = "IProductType operations">

    private _ProductType: IProductType

    get ProductType(): IProductType {
        return this._ProductType
    }

    async IProductType_OnLoadComplete(): Promise<void> {
        const self = this

        let ptrow = self.drWB_ProductGroup?.WB_ProductTypeRow
        let ptr = ptrow?.cif

        let pt: IProductType = {
            id: ptr?.WB_PRDM_ID || 0,
            id_ui: ptr?.PRDM_ID || 'Not Typed',
            name: ptr?.PRDM_NAME || 'Not Typed',
            bStatusShowInd: !!ptrow?.bStatusShowInd,
            bStatusSearchByInd: !!ptrow?.bStatusSearchByInd,
            bSalesAreaShowInd: !!ptrow?.bSalesAreaShowInd,
            bSalesAreaSearchByInd: !!ptrow?.bSalesAreaSearchByInd,
            bProductSizesShowInd: false,
            bProductSizesSearchByInd: false,
            bConsumerUPCShowInd: false,
            bConsumerUPCSearchByInd: false,
            bUOMShowInd: !!ptrow?.bUOMShowInd,
            bUOMSearchByInd: !!ptrow?.bUOMSearchByInd,
            bBOMShowInd: false,
            bBOMSearchByInd: false,
            ProductFieldsShowInd: {},
            SalesAreaFieldsShowInd: {}
        }

        if (_.isEmpty(ptrow)) {
            // Default items to show
            pt.bSalesAreaShowInd = true
            pt.bSalesAreaSearchByInd = true
        }

        let dctHeaderShowFields = _.keyBy((ptr?.HEADER_SHOW_FIELDS || "").split(","), (a) => a)


        _.forEach(ProductHeaderFields, (a) => {
            pt.ProductFieldsShowInd[a] = (a in dctHeaderShowFields)
        })

        self._ProductType = pt

    }


    //</editor-fold>

    //<editor-fold desc = "Entity - Attributes">

    private productEntity: ProductEntity

    Entity_init(): void {

    }

    async Entity_OnLoadComplete(): Promise<void> {
        this.productEntity = new ProductEntity({ productGroupRow: this.drWB_ProductGroup })
        await this.productEntity.OnLoadComplete()
    }

    get Entity(): IEntity {
        return this.productEntity
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveTag operations">

    _bIHaveTagsLoaded: boolean;
    _OnIHaveTagsLoaded: Promise<IHaveTags>;
    _TagsChanged: BehaviorSubject<IHaveTags>;
    _AllTags: WB_TagRow[];
    _TagUsageId: string;


    IHaveTagsLoaded_init() {
        this._bIHaveTagsLoaded = false
        this._OnIHaveTagsLoaded = undefined
        this._TagsChanged = new BehaviorSubject<IHaveTags>(this)
        this._AllTags = undefined
        this._TagUsageId = 'AllTagUsage'
    }

    get bIHaveTagsLoaded() {
        return this._bIHaveTagsLoaded
    }

    get TagsReadOnly(): boolean {
        if (this._bIsDeleted) {
            return true
        }
        // Check User Roles ?
        return false
    }

    get Tags(): WB_TagRow[] {
        var returnValue: WB_TagRow[] = []

        _.forEach(this.drWB_ProductGroup.WB_ProductGroupTagRelationshipRows, (aWBGrpTagRow: WB_ProductGroupTagRelationshipRow) => {
            if (aWBGrpTagRow && aWBGrpTagRow.isActive && aWBGrpTagRow.WB_TagRow) {
                returnValue.push(aWBGrpTagRow.WB_TagRow)
            }
        })

        return returnValue
    }

    get TagsChanged(): BehaviorSubject<IHaveTags> {
        return this._TagsChanged
    }

    get AllTags(): WB_TagRow[] {
        if (this._AllTags) {
            return this._AllTags
        } else {
            return []
        }
    }

    get UsageId(): string {
        return this._TagUsageId
    }

    get OnIHaveTagsLoaded(): Promise<IHaveTags> {
        const self = this;

        if (self._bIHaveTagsLoaded) {
            return ASync.resolve(self)
        }

        if (!_.isEmpty(self._OnIHaveTagsLoaded)) {
            return self._OnIHaveTagsLoaded;
        }

        self._OnIHaveTagsLoaded = new Promise<IHaveTags>((resolve, error) => {
            // If the BO is not loaded, throw an error.. It should have been started
            if ((!(self.bIsLoaded)) && (_.isEmpty(self.OnLoadComplete))) {
                error("Product Group isn't Loaded or Loading.. Can't determine Tags");
                return;
            }

            var loadWait: Promise<any> = undefined

            if (self.bIsLoaded) {
                loadWait = ASync.resolve(self)
            } else {
                loadWait = self.OnLoadComplete
            }

            loadWait
                .then((aProductBO) => {
                    if (!(aProductBO.bIsLoaded)) {
                        error("Waited on Product Group Load to complete but still isn't Loaded");
                        return
                    }

                    return self.dbContext.findAll(esWB_Tag_Source, { TAG_SOURCE_ID: 'PRODUCT' })
                })
                .then((sourceRows: WB_TagSourceRow[]) => {
                    let source_id = 0
                    if (sourceRows) {
                        source_id = sourceRows[0].cif.WB_TAG_SOURCE_ID
                    }
                    return self.dbContext.findAll(esWB_Tag, { WB_TAG_SOURCE_ID: source_id })
                })
                .then((arrResultRows: WB_TagRow[]) => {
                    if (!_.isEmpty(arrResultRows)) {
                        self._AllTags = arrResultRows
                    } else {
                        self._AllTags = []
                    }

                    self._bIHaveTagsLoaded = true
                    self._OnIHaveTagsLoaded = undefined
                    resolve(self);
                    return
                })
                .catch((err) => {
                    self._OnIHaveTagsLoaded = undefined
                    error(err)
                });
        })

        return self._OnIHaveTagsLoaded
    }

    addTag(TagId: number): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            var aTagRow: WB_TagRow = undefined
            self.dbContext.find(esWB_Tag, TagId)
                .then((aNewRow: WB_TagRow) => {
                    if (!(aNewRow)) {
                        error("Unable to find Tag to add to Product Group. " + TagId)
                        return
                    }

                    aTagRow = aNewRow

                    return self.dbContext.createRecordWithKey(esWB_Product_Group_Tag_Relationship)

                })
                .then((aWBGrpTag: WB_ProductGroupTagRelationshipRow) => {
                    //
                    if (!(aWBGrpTag)) {
                        error("Unable to create Product Group Tag record add to Product Group. ")
                        return
                    }
                    aWBGrpTag.setDefaults()
                    aWBGrpTag.WB_TagRow = aTagRow
                    aWBGrpTag.cif.WB_TAG_ID = aTagRow.cif.WB_TAG_ID
                    aWBGrpTag.cif.WB_PRDGRP_ID = self.drWB_ProductGroup.cif.WB_PRDGRP_ID
                    aWBGrpTag.cif.TAG_METHOD = "Manual"
                    aWBGrpTag.WB_TagRow = aTagRow
                    self.dbContext.add(esWB_Product_Group_Tag_Relationship, aWBGrpTag)
                    self.TagsChanged.next(self)
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })

    }

    removeTag(TagId: number): void {
        const self = this
        var changed = false
        _.forEach(this.drWB_ProductGroup.WB_ProductGroupTagRelationshipRows, (aWBGrpTagRow: WB_ProductGroupTagRelationshipRow) => {
            if (aWBGrpTagRow && aWBGrpTagRow.isActive && aWBGrpTagRow.WB_TagRow) {
                if (aWBGrpTagRow.WB_TagRow.cif.WB_TAG_ID == TagId) {
                    aWBGrpTagRow.markDeleted()
                    changed = true
                }
            }
        })

        if (changed) {
            self.TagsChanged.next(self)
        }
    }

    hasTag(TagId: number): boolean {
        var found = false

        _.forEach(this.drWB_ProductGroup.WB_ProductGroupTagRelationshipRows, (aWBGrpTagRow: WB_ProductGroupTagRelationshipRow) => {
            if (aWBGrpTagRow && aWBGrpTagRow.isActive && aWBGrpTagRow.WB_TagRow) {
                if (aWBGrpTagRow.WB_TagRow.cif.WB_TAG_ID == TagId) {
                    found = true
                    return false // stop iterating
                }
            }
        })

        return found
    }

    setDateRange(TagId: number, DateRange: IDateRange): void {
        _.forEach(this.drWB_ProductGroup.WB_ProductGroupTagRelationshipRows, (aWBGrpTagRow: WB_ProductGroupTagRelationshipRow) => {
            if (aWBGrpTagRow && aWBGrpTagRow.isActive && aWBGrpTagRow.WB_TagRow) {
                if (aWBGrpTagRow.WB_TagRow.cif.WB_TAG_ID == TagId) {
                    aWBGrpTagRow.cif.EFFECTIVE_START_DT = DateRange.StartDt.getFullYear().toString() + ('0' + (DateRange.StartDt.getMonth() + 1)).slice(-2) + ('0' + DateRange.StartDt.getDate()).slice(-2)
                    aWBGrpTagRow.cif.EFFECTIVE_END_DT = DateRange.EndDt.getFullYear().toString() + ('0' + (DateRange.EndDt.getMonth() + 1)).slice(-2) + ('0' + DateRange.EndDt.getDate()).slice(-2)
                    return
                }
            }
        })
    }

    getDateRange(TagId: number): IDateRange {
        let aDateRange: IDateRange = {}
        _.forEach(this.drWB_ProductGroup.WB_ProductGroupTagRelationshipRows, (aWBGrpTagRow: WB_ProductGroupTagRelationshipRow) => {
            if (aWBGrpTagRow && aWBGrpTagRow.isActive && aWBGrpTagRow.WB_TagRow) {
                if (aWBGrpTagRow.WB_TagRow.cif.WB_TAG_ID == TagId) {
                    aDateRange.StartDt = new Date(Number(aWBGrpTagRow.cif.EFFECTIVE_START_DT.slice(0, 4)), Number(aWBGrpTagRow.cif.EFFECTIVE_START_DT.slice(4, 6)) - 1, Number(aWBGrpTagRow.cif.EFFECTIVE_START_DT.slice(6, 8)))
                    aDateRange.EndDt = new Date(Number(aWBGrpTagRow.cif.EFFECTIVE_END_DT.slice(0, 4)), Number(aWBGrpTagRow.cif.EFFECTIVE_END_DT.slice(4, 6)) - 1, Number(aWBGrpTagRow.cif.EFFECTIVE_END_DT.slice(6, 8)))

                    return aDateRange
                }
            }
        })

        return aDateRange
    }

    //</editor-fold>


    //<editor-fold desc = "UOM operations">


    async addUOMRow(uomCd: string): Promise<WB_ProductGroupUOMRow> {
        const self = this

        let newRow: WB_ProductGroupUOMRow = <WB_ProductGroupUOMRow>await self.dbContext.createRecordWithKey(esWB_Product_Group_UOM, {})
        newRow.setDefaults()
        newRow.cif.WB_PRDGRP_ID = self.WB_ProductGroup.cif.WB_PRDGRP_ID
        newRow.WB_ProductGroupRow = self.WB_ProductGroup
        newRow.cif.PRODUCT_UOM = uomCd
        self.dbContext.add(esWB_Product_Group_UOM, newRow)
        return newRow
    }

    async removeUOMRow(wbPrdGrpUOMId: number): Promise<void> {
        const self = this

        _.forEach(self.WB_ProductGroup.WB_ProductGroupUOMRows, (a) => {
            if (!a.isActive)
                return
            if (a.cif.WB_PRDGRP_UOM_ID == wbPrdGrpUOMId) {
                a.markDeleted()
                return false
            }
        })
    }

    getUOMRow(uomCd: string, EffectiveDt?: Date): WB_ProductGroupUOMRow {
        const self = this
        let bCheckDate = _.isDate(EffectiveDt)
        let sDt: string
        if (bCheckDate)
            sDt = DateUtils.convertToSAPBW(EffectiveDt)
        let evalRows = _.filter(self.WB_ProductGroup.WB_ProductGroupUOMRows, (a) => a.isActive && (a.cif.PRODUCT_UOM == uomCd))
        evalRows = _.sortBy(evalRows, ['EFFECTIVE_END_DT', 'EFFECTIVE_START_DT'], ['desc', 'desc'])
        for (let aRow of evalRows) {

            if (!bCheckDate)
                return aRow

            if (sDt >= aRow.cif.EFFECTIVE_START_DT && sDt <= aRow.cif.EFFECTIVE_END_DT)
                return aRow

        }
        return undefined
    }


    async generateUOMs(pOptions: IGenerateUOMOptions): Promise<IMessageProvider> {
        const self = this
        //--
        // Get the Products in the named Hierarchy
        let arrWbProdIds: number[] = []
        let hierStartDt = _.isDate(pOptions.HierarchyEffectiveStartDt) ? pOptions.HierarchyEffectiveStartDt : DateUtils.today
        let hierEndDt = _.isDate(pOptions.HierarchyEffectiveEndDt) ? pOptions.HierarchyEffectiveEndDt : DateUtils.addDays(DateUtils.today, 365)
        arrWbProdIds = await ProductHierarchyService.getChildren(pOptions.wbPrdHId, self.WB_ProductGroup.cif.WB_PRDGRP_ID, hierStartDt, hierEndDt, "Product")
        let options = _.cloneDeep(pOptions)
        options.WbProdIds = arrWbProdIds

        let UOMEffDate = pOptions.EffectiveDate || DateUtils.today
        let logger = new AuditService()
        logger.setReference("ProductGroup", self.WB_ProductGroup.cif.WB_PRDGRP_ID)
        options.AuditLogger = logger
        let results = await ProductUOMUtils.CalculateUOMs(options)
        await logger.Save()

        // Check if BaseUOM needs to be set
        if (options.bDeriveUOM)
            self.WB_ProductGroup.cif.BASE_UOM = results.BaseUOM

        // Sync Up the Conversion Factors that are Factors
        for (let aUOMCd in results.dctUOMs) {
            let conversionFactor = results.dctUOMs[aUOMCd]
            let row = self.getUOMRow(aUOMCd, UOMEffDate)
            if (row) {
                //-- Overwrites History, vs check if change creates new record
                row.cif.CONVERSION_FACTOR = conversionFactor
                continue
            } else {
                row = self.getUOMRow(aUOMCd)
                let sExistingEndDt
                if (row) {
                    // Doesn't overlap
                    sExistingEndDt = row.cif.EFFECTIVE_END_DT
                }
                //--
                let newRow = await self.addUOMRow(aUOMCd)
                newRow.setDefaults()
                newRow.cif.CONVERSION_FACTOR = conversionFactor
                newRow.cif.SOURCE_ID = 'WB'
                if (sExistingEndDt && sExistingEndDt != '99991231') {
                    // Change the Start Dt to EndDate + 1
                    //-- If needed, update this logic
                    let existingDt = DateUtils.convertFromSAPBW(sExistingEndDt)
                    if (_.isDate(existingDt)) {
                        existingDt = DateUtils.addDays(existingDt, 1)
                        newRow.cif.EFFECTIVE_START_DT = DateUtils.convertToSAPBW(existingDt)
                    }
                }
            }
        }

        return results.Messages
    }

    //</editor-fold>

    //<editor-fold desc = "Record Resolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const prdgrp_options: CreateOptions = {
            standardConditions: {
                [esWB_Finished_Product_Relationship]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_Product_Group_Relationship]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_Product_Group_External_Relationship]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_Product_Group_Tag_Relationship]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_Finished_Product]: { "DELETED_IND": { "notIn": ['1'] } }
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Product_Group]: [esWB_Finished_Product],
                [esWB_Finished_Product]: [esWB_Product_UOM],
                [esWB_SalesArea]: [esWB_SalesOrg, esWB_Division, esWB_DistribChannel]

            }
        }

        const aRecResolver = new ESRecordResolver(dbContext, prdgrp_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Product_Group, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>


};
PAEnvironment.registerBusinessObjectClass(ProductGroupBO, "ProductGroupBO", "Product Group")